import { AngleDoubleLeftIcon, AngleDoubleRightIcon, CaretLeftIcon, CaretRightIcon } from '@panwds/icons';
import { addMonths, addYears, endOfMonth, endOfYear, format, isAfter, isBefore, startOfMonth, startOfYear } from 'date-fns';
import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from '../../Button/index.js';
import { Bold } from '../../Typography/index.js';
export function Header({ activeDate, max, min, onActiveDateChange, onKeyDown }) {
    const intl = useIntl();
    return (React.createElement("div", { className: "tw-flex tw-justify-around tw-items-center" },
        React.createElement(Button, { appearance: "tertiary-clear", "aria-label": intl.formatMessage({
                defaultMessage: 'Previous year',
                id: 'uY7HPg',
                description: 'Button to change to previous year'
            }), disabled: min && isBefore(endOfYear(addYears(activeDate, -1)), min), icon: React.createElement(AngleDoubleLeftIcon, { size: "xs" }), onClick: () => {
                onActiveDateChange((activeDate) => addYears(activeDate, -1));
            }, onKeyDown: onKeyDown, size: "sm" }),
        React.createElement(Button, { appearance: "tertiary-clear", "aria-label": intl.formatMessage({
                defaultMessage: 'Previous month',
                id: 'k1Ca1t',
                description: 'Button to change to previous month'
            }), disabled: min && isBefore(endOfMonth(addMonths(activeDate, -1)), endOfMonth(min)), icon: React.createElement(CaretLeftIcon, { size: "xs" }), onClick: () => {
                onActiveDateChange((activeDate) => addMonths(activeDate, -1));
            }, onKeyDown: onKeyDown, size: "sm" }),
        React.createElement(Bold, { addClassName: "tw-font-bold tw-text-xl", "aria-live": "polite" }, format(activeDate, 'MMM Y')),
        React.createElement(Button, { appearance: "tertiary-clear", "aria-label": intl.formatMessage({
                defaultMessage: 'Next month',
                id: 'ues+PY',
                description: 'Button to change to next month'
            }), disabled: max && isAfter(startOfMonth(addMonths(activeDate, 1)), max), icon: React.createElement(CaretRightIcon, { size: "xs" }), onClick: () => {
                onActiveDateChange((activeDate) => addMonths(activeDate, 1));
            }, onKeyDown: onKeyDown, size: "sm" }),
        React.createElement(Button, { appearance: "tertiary-clear", "aria-label": intl.formatMessage({
                defaultMessage: 'Next year',
                id: 'kCI2cC',
                description: 'Button to change to next year'
            }), disabled: max && isAfter(startOfYear(addYears(activeDate, 1)), max), icon: React.createElement(AngleDoubleRightIcon, { size: "xs" }), onClick: () => {
                onActiveDateChange((activeDate) => addYears(activeDate, 1));
            }, onKeyDown: onKeyDown, size: "sm" })));
}
//# sourceMappingURL=Header.js.map